import {invert, isArray} from "lodash";
import React, {useEffect, useMemo, useState} from "react";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {
    animalListMapFields,
    animalListMapSQL,
    mapSQL,
} from "../../../../constans/sqlSelects";
import useQueryCaller from "../../../../hooks/useQueryCaller";
import {getMapSQLData} from "../../../../selectors/animalParametersSelector";
import TableGrid from "../../../basics/table-grid/TableGrid";
import AnimalReferenceDocumentModalGrid from "../../../grids/animal-reference-document/AnimalReferenceDocumentModalGrid";
import LoadingComponent from "../../../loading/LoadingComponent";

export function FilterAnimalDrawerContentRenderer({AnmIDs, sql, parameters}) {
    const {t} = useTranslation();

    const [result, setResult] = useState([]);
    const [loading, setLoading] = useState(false);

    const callQuery = useQueryCaller();

    const name = useMemo(() => {
        const invertedMapSQL = invert(mapSQL);
        return invertedMapSQL[sql];
    }, [sql]);

    useEffect(() => {
        if (AnmIDs.length === 0) {
            setResult([]);
            return;
        }
        const tmp = name
            ? animalListMapSQL[name]
            : sql
              ? sql +
                " AND AnmID IN @(?) ORDER BY AnmNo1::NUMBER ASC, AnmNo1 ASC"
              : null;
        if (!tmp) {
            setResult([]);
            return;
        }

        async function fetchData() {
            setLoading(true);
            try {
                const res = await callQuery(tmp, [...parameters, AnmIDs]);
                setResult(res);
            } catch (e) {
                console.error(e);
            }
            setLoading(false);
        }

        fetchData();
    }, [AnmIDs, callQuery, sql, parameters, name]);

    const headers = useMemo(() => {
        if (!name) {
            return [
                {
                    name: t("animalNumber"),
                    field: "AnmID",
                    component: <AnimalReferenceDocumentModalGrid />,
                },
                {name: t("value"), field: "value"},
            ];
        }
        return [
            {
                name: t("animalNumber"),
                field: "AnmID",
                component: <AnimalReferenceDocumentModalGrid />,
            },
            ...animalListMapFields[name].map((row) => ({
                name: t(row.translationKey),
                field: row.field,
                valueFormatter: row.valueFormatter,
            })),
        ];
    }, [name, t]);

    if (!isArray(result) || result.length === 0) return null;
    return (
        <div className="position-relative">
            <LoadingComponent isLoading={loading} />
            <TableGrid
                headers={headers}
                data={result}
                shouldIndex
                showPagination
                paginationItems={10}
                smallPagination
            />
        </div>
    );
}

export default function FilterAnimalDrawerContent({animals}) {
    const mapSQLData = useSelector(getMapSQLData);

    const AnmIDs = useMemo(() => animals.map(({AnmID}) => AnmID), [animals]);

    return (
        <FilterAnimalDrawerContentRenderer
            AnmIDs={AnmIDs}
            sql={mapSQLData.sql}
            parameters={mapSQLData.params}
        />
    );
}
